import { render, staticRenderFns } from "./approvedInterReturnExchange.vue?vue&type=template&id=33e4c614"
import script from "./approvedInterReturnExchange.vue?vue&type=script&lang=js"
export * from "./approvedInterReturnExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports